import React, { useState } from 'react'
import "./StickyMenu3.css"
import {globals} from '../Globals/Globals'
import { Button } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { revertAllEvents } from '../../redux/eventSlice';
import { openModal } from '../../redux/modalSlice';
import { logout } from '../../redux/authSlice';
import { Link } from 'react-router-dom';

function StickyMenu3 (props) {
    let navbar_top_ref = React.createRef();
    let navbar_intitial_offset_top = -1;
    let [Collapsed,setCollapsed] = useState(true);
    let [Toggle,setToggle] = useState(false);
    let [Toggle2,setToggle2] = useState(false);
    //let [navBackColor,setNavBackColor] = useState(props.navBackColor?props.navBackColor:"transparent");
    let [navBackColor,setNavBackColor] = useState(props.navBackColor?props.navBackColor:"black");//Force back color to black
    let {isAuthenticated} = useSelector((state) => state.auth);
    let dispatch = useDispatch();

    const rendering = () => {        
        return(
            <>
                <nav 
                    ref={navbar_top_ref} 
                    id="navbar_top" 
                    className="navbar navbar-expand-lg navbar-dark"
                    style={{backgroundColor:`${navBackColor}`}}
                    >
                    <div className="container">
                        <div className='navbar-website-icon'/>
                        <Link to="/" className="navbar-brand">{globals.parameters.website}</Link>

                        <button onClick={()=>{setCollapsed(!Collapsed);}} className={`navbar-toggler ${Collapsed?"collapsed":""}`} type="button" data-toggle="collapse" data-bs-target="#main_nav" aria-expanded={`${Toggle?"true":"false"}`} aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className={`collapse navbar-collapse ${Collapsed?"collapse":"collapse show"}`} id="main_nav">
                            <ul className="navbar-nav ms-auto">
                                <li className="nav-item"><Link to="/" className="nav-link">Accueil</Link></li>
                                <li className="nav-item"><a className="nav-link" href="/dailyworship">Méditation du jour</a></li>
                                <li className="nav-item"><a className="nav-link" href="/bibleread">{globals.menu.bible_read}</a></li>
                                {/** 
                                <li className="nav-item"><a className="nav-link" href="/chain">{globals.menu.chainmenu}</a></li>*/}
                                
                                <li className="nav-item"><a className="nav-link" href="."
                                    onClick={e => {e.preventDefault(); dispatch(openModal({title:`${globals.menu.about_us} - version ${globals.menu.version}`}));}}
                                    >{globals.menu.about_us}</a></li>

                                {/**  Admin submenu */} 
                                {isAuthenticated &&
                                 <Link to="/eventsadmin" className="btn-round btn btn-danger">{globals.menu.eventsadmin}</Link>}
                                {!isAuthenticated &&
                                <li className="nav-item"><a className="nav-link btn btn-primary" href="/authent">Connexion</a></li>}
                                {isAuthenticated &&
                                <Button className='btn-success' onClick={()=>{dispatch(revertAllEvents());dispatch(logout());}}>Déconnexion</Button>}
                            </ul>

                        </div> {/*<!-- navbar-collapse.// -->*/}
                    </div> {/*<!-- container-fluid.// -->*/}
                </nav>
            </>
        )
    } 

    return(
        <>
            {rendering()}
        </>
    )
}

export default StickyMenu3;